module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/EmailTemplate/EmailTemplate-list/EmailTemplate-list.component.css
// module id = ./src/app/EmailTemplate/EmailTemplate-list/EmailTemplate-list.component.css
// module chunks = main